<div class="box-shadow module">
  <div class="row">
    <h2>{{ "Feedback" | translate }}</h2>
  </div>
  <p-messages [(value)]="messages"></p-messages>
  <div class="top-controls">
    <p-dropdown id="buName" [appBUSwitcher]="selectedBusinessUnit" [(ngModel)]="selectedBusinessUnit"
      [options]="businessUnits" (onChange)="loadItems()" optionLabel="Name" appendTo="body"
      [style]="{ marginRight: '10px' }">
      <ng-template let-item pTemplate="selectedItem">{{ item.value?.Name | translate }}</ng-template>
      <ng-template let-item pTemplate="item">{{ item.value?.Name | translate }}</ng-template>
    </p-dropdown>
  </div>

  <div *ngIf="selectedBusinessUnit.SupportInfo != null" class="row group">
    <div class="group-header">
      <h3>{{ "ePSSRBUSupportInformation" | translate }}</h3>
    </div>
        <div [innerHTML]="selectedBusinessUnit.SupportInfo"></div>
  </div>
  <div class="row group">
    <div class="group-header">
      <h3>{{ "ePSSR Service Now Ticketing Instructions" | translate }}</h3>
    </div>
    <ol>
      <li [innerHTML]="'ApplicationSupportRequestForm'|translate"></li>
      <li [innerHTML]="'UndertheApplicationFieldselectMobilePSSR'|translate"></li>
      <li [innerHTML]="'ToreportanissueorbugpleaseselectReportanIssueTosubmitanenhancementrequestoruseraccessrequestpleaseselectServiceRequestHitNext'|translate"></li>
    </ol>
  </div>
  <div class="row group">
    <div class="group-header">
      <h4>{{ "Report an Issue" | translate }} </h4>
    </div>
    <ol>
      <li [innerHTML]="'FillouttheDescriptionoftheProblemImpactandUrgency'|translate"></li>
      <li [innerHTML]="'PressNextandthenSubmit'|translate"></li>
      <li [innerHTML]="'TheePSSRSupportTeamwillacknowledgethereceiptoftheticketin24hoursduringbusinesshours'|translate"></li>
    </ol>
  </div>
  <div class="row group">
    <div class="group-header">
      <h4> {{ "Enhancement Request" | translate }} </h4>
    </div>
    <ol>
      <li [innerHTML]="'PleaseselectEnhancementsunderTypeofRequests'|translate"></li>
      <li [innerHTML]="'SelectPriorityLowModerateHigh'|translate"></li>
      <li [innerHTML]="'FillouttheDescriptionofRequest'|translate"></li>
      <li [innerHTML]="'SelectNextandSubmit'|translate"></li>
      <li [innerHTML]="'TheePSSRSupportTeamwillreviewenhancementrequestsaspartoftheSurfaceDigitalPIPlanningProcess'|translate"></li>
      
    </ol>
  </div>
  <div class="row group">
    <div class="group-header">
      <h4>{{ "User Access Request" | translate }} </h4>
    </div>
    <ol>
      <li [innerHTML]="'PleaseselectRequestAccessunderTypeofRequests'|translate"></li>
      <li [innerHTML]="'SelectAccessRequestTypeAddorRemove'|translate"></li>
      <li [innerHTML]="'SelectUser'|translate"></li>
      <li [innerHTML]="'SelectPriorityLowModerateHigh'|translate"></li>
      <li [innerHTML]="'SpecifyRoleandAccesstheUserneeds'|translate"></li>
      <li [innerHTML]="'SelectNextandSubmit'|translate"></li>
      <li [innerHTML]="'TheePSSRSupportTeamwillacknowledgethereceiptoftheticketin24hoursduringbusinesshours'|translate"></li>
    </ol>
  </div>
</div>